import { BellOutlined } from '@ant-design/icons';
import { Button, Popover } from 'antd';
import React, { useCallback, useState } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';

import NotificationBadge from '../../../../components/NotificationBadge';
import NotificationList from '../../../../components/NotificationList';
import paths from '../../../../paths.json';
import HeaderButton from '../Button';

import styles from './styles.module.less';

const NotificationButton = () => {
  const [open, setOpen] = useState(false);
  const match = useRouteMatch([
    `*/:messageId([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})`,
  ]);

  const onOpenChange = useCallback(
    (open: boolean) => {
      if (Boolean(match) && !open) {
        setOpen(true);
      } else {
        setOpen(open);
      }
    },
    [match],
  );

  return (
    <Popover
      arrowPointAtCenter
      content={
        <>
          <NotificationList />
          <div className={styles.footer}>
            <Link to={`${paths.notifications}/app`}>
              <Button
                block
                className={styles.button}
                onClick={() => {
                  setOpen(false);
                }}
                type="link"
              >
                See All Notifications
              </Button>
            </Link>
          </div>
        </>
      }
      onOpenChange={onOpenChange}
      open={open}
      overlayClassName={styles.overlay}
      placement="bottomLeft"
      trigger="click"
    >
      <NotificationBadge className={styles.badge} offset={[-8, 14]}>
        <HeaderButton icon={<BellOutlined style={{ fontSize: 18 }} />} />
      </NotificationBadge>
    </Popover>
  );
};

NotificationButton.displayName = 'NotificationButton';

export default NotificationButton;
